import React from 'react';
import i18n from '../../i18n'; 
import LanguageDropdown from '../LanguageDropdown';

const LanguageSwitcher = () => {
  const languageOptions = [
    { id: 'en', name: 'ENG' },
    { id: 'si', name: 'සිංහල' },
    { id: 'ta', name: 'தமிழ்' },
  ];

  const handleLanguageChange = (option) => {
    i18n.changeLanguage(option.id);
  };

  return (
    <LanguageDropdown
      options={languageOptions}
      placeholder="Select Language"
      onSelect={handleLanguageChange}
    />
  );
};

export default LanguageSwitcher;
